import type { StatusTone } from '@/shared/ui/status-badge'

interface StatusMeta {
  label: string
  tone: StatusTone
}

const fallback = (status: string): StatusMeta => ({ label: status || '—', tone: 'muted' })

const accountStatuses: Record<string, StatusMeta> = {
  unverified: { label: 'Не проверена', tone: 'muted' },
  verifying: { label: 'Проверка', tone: 'info' },
  active: { label: 'Активна', tone: 'ok' },
  degraded: { label: 'Деградация', tone: 'warn' },
  failed: { label: 'Сбой', tone: 'danger' },
  disabled: { label: 'Отключена', tone: 'muted' },
}

export function accountStatus(status: string): StatusMeta {
  return accountStatuses[status] ?? fallback(status)
}

const poolStatuses: Record<string, StatusMeta> = {
  active: { label: 'Активен', tone: 'ok' },
  disabled: { label: 'Выключен', tone: 'muted' },
}

export function poolStatus(status: string): StatusMeta {
  return poolStatuses[status] ?? fallback(status)
}

const leaseStatuses: Record<string, StatusMeta> = {
  registering: { label: 'Регистрация', tone: 'info' },
  active: { label: 'Активна', tone: 'ok' },
  draining: { label: 'Дренаж', tone: 'warn' },
}

export function leaseStatus(status: string): StatusMeta {
  return leaseStatuses[status] ?? fallback(status)
}

const markingStatuses: Record<string, StatusMeta> = {
  none: { label: 'Без маркировки', tone: 'muted' },
  contracted: { label: 'Договор', tone: 'info' },
  active: { label: 'Маркируется', tone: 'ok' },
}

export function markingStatus(status: string): StatusMeta {
  return markingStatuses[status] ?? fallback(status)
}

export const marketLabels: Record<string, string> = {
  ru: 'Россия',
  sa: 'Саудовская Аравия',
  eu: 'Европа',
}

export function marketLabel(market: string): string {
  return marketLabels[market] ?? market
}

export const ownerTypeLabels: Record<string, string> = {
  platform: 'Платформа',
  client: 'Клиент (BYOC)',
}

export function ownerTypeLabel(ownerType: string): string {
  return ownerTypeLabels[ownerType] ?? ownerType
}
